module.exports = __webpack_public_path__ + "static/media/classroom_bottom_close_2.e32b5e2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/classroom/classroom_bottom_close_2.png
// module id = 1881
// module chunks = 6